export default "__VITE_ASSET__FDBm6_V5__"